module.exports = __webpack_public_path__ + "static/media/icon_del.c069a635.svg";